// pages/PaymentHistory.jsx

import React from "react";
import { Table, Input, Button, Modal, Switch } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import usePaymentHistory from "../../../hooks/AdminDashboard/usePaymentHistory";
function PaymentHistory() {
	const {
		setSearchTerm,
		isModalVisible,
		modalType,
		selectedPayment,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		filteredPayments,
		handleSwitch,
	} = usePaymentHistory();

	const columns = [
		{ title: "Student Name", dataIndex: "student", key: "student" },
		{ title: "Amount", dataIndex: "amount", key: "amount" },
		{ title: "Payment Date", dataIndex: "paymentDate", key: "paymentDate" },
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => {
				let color;

				if (
					status.toLowerCase() === "completed" ||
					status.toLowerCase() === "success"
				) {
					color = "#52c41a"; // Green
				} else if (
					status.toLowerCase() === "pending" ||
					status.toLowerCase() === "overdue" ||
					status.toLowerCase() === "not verified"
				) {
					color = "#faad14"; // Gold
				} else if (status.toLowerCase() === "deleted") {
					color = "#ff4d4f"; // Red
				}
				return <span style={{ color }}>{status}</span>;
			},
		},
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<EyeOutlined />}
						onClick={() => showModal("view", record)}
					/>
					<Switch
						checked={
							record.status.toLowerCase() === "success" ||
							record.status.toLowerCase() === "completed"
						}
						onChange={(value) => handleSwitch(value, record)}
					/>
				</span>
			),
		},
	];

	const renderFormContent = () => {
		switch (modalType) {
			case "view":
				return (
					<div>
						<p>
							<strong>Student Name:</strong>{" "}
							{selectedPayment.student}
						</p>
						<p>
							<strong>Amount:</strong> ${selectedPayment.amount}
						</p>
						<p>
							<strong>payment date:</strong>{" "}
							{selectedPayment.paymentDate}
						</p>
						<p>
							<strong>For course:</strong>{" "}
							{selectedPayment.course}
						</p>
						<p>
							<strong>Status:</strong>{" "}
							<span
								style={{
									color: getStatusColor(
										selectedPayment.status
									),
								}}
							>
								{selectedPayment.status}
							</span>
						</p>
					</div>
				);

			default:
				return null;
		}
	};

	const getStatusColor = (status) => {
		switch (status) {
			case "Completed":
				return "#52c41a"; // Green
			case "Pending":
			case "Overdue":
				return "#faad14"; // Gold
			case "Deleted":
				return "#ff4d4f"; // Red
			default:
				return "#000"; // Default color
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Payment History</h2>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
				<Input.Search
					placeholder="Search by student name..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
				{/* <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => showModal("add")}
          className="w-full bg-blue-500 hover:bg-blue-600"
        >
          Add Payment
        </Button> */}
			</div>

			<Table
				columns={columns}
				dataSource={filteredPayments}
				rowKey="id"
				pagination={{ position: ["bottomRight"] }}
				className="w-full"
			/>

			<Modal
				title={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Payment`}
				open={isModalVisible}
				onOk={handleModalConfirm}
				onCancel={handleModalCancel}
				okText={modalType === "delete" ? "Confirm" : "Submit"}
				cancelText="Cancel"
				destroyOnClose
				footer={modalType === "view" ? null : undefined}
			>
				{renderFormContent()}
			</Modal>
		</div>
	);
}

export default PaymentHistory;
